<div class="fm-google-maps-light"
  #mapLightHostElement></div>
